import React from 'react';
import { routes } from 'routes';
import { colors } from 'globalStyle';
import { Box, Grid } from '@material-ui/core';
import { Text, Title, Bold } from 'components/Texts';
import Image from 'assets/persons/goal-3.svg';
import ModalContent from 'components/Modals/ModalContent';
import { Hollow, hollowColorType } from 'components/Buttons';

export default function RegisterCompletionStep1({ onFinish, onClose, isDesktop }) {
  const textProps = {
    isCenter: true,
    color: colors.WHITE,
  };
  return (
    <ModalContent
      width="615px"
      height="530px"
      onClose={onClose}
      bg={colors.primary}
      color={colors.WHITE}
      pt={isDesktop && '48px'}
      iconColor={colors.WHITE}
    >
      <Grid container direction="column" alignItems="center">
        <Box
          src={Image}
          component="img"
          width="162.869px"
          height="156.765px"
        />
        <Title mt={isDesktop ? 7.23 : 23.83} mb={24} size={24} {...textProps}>¡Felicidades!</Title>
        <Text size={isDesktop ? 16 : 15} lineHeight={!isDesktop && '166.667%'} maxWidth="449px" {...textProps}>
          <p>
            Has concluido la primera fase del registro,
            cada vez estás más cerca de completar tu perfil y
            <Bold>{' poder invertir.'}</Bold>
          </p>
        </Text>
        {isDesktop && (
          <Text mt={15} size={16} maxWidth="414px" {...textProps}>
            <p>
              Ahora puedes revisar todos los documentos de cada uno de
              <Bold>{' nuestros proyectos.'}</Bold>
            </p>
          </Text>
        )}
      </Grid>
      <Box
        display="flex"
        flexWrap="wrap"
        gridColumnGap="19px"
        alignItems="baseline"
        justifyContent="center"
        flexDirection={isDesktop ? 'row' : 'column-reverse'}
      >
        <Box
          width={isDesktop ? '220px' : '100%'}
        >
          <Hollow
            fullWidth
            onClick={onClose}
            href={routes.home}
            onColorType={hollowColorType.primaryBorder}
          >
            Explorar
          </Hollow>
        </Box>
        <Box
          width={isDesktop ? '220px' : '100%'}
          marginTop={isDesktop ? '35px' : '20px'}
          marginBottom={isDesktop ? '0px' : '20px'}
        >
          <Hollow
            isSubmit
            fullWidth
            onClick={onFinish}
            onColorType={hollowColorType.WHITE}
          >
            Completar perfil
          </Hollow>
        </Box>
      </Box>
    </ModalContent>
  );
}
